import { useQuery } from '@tanstack/react-query';

import { ActiveStayPeriod } from 'src/features/stay/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/visitors/past-stay/:stayId/past-stay-period/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    stayId: string;
}

const queryFn = ({ stayId, parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<ActiveStayPeriod>> => {
    return axios.get(formatResourcePath(RESOURCE, { stayId, parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}

const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_PAST_STAY_PERIODS_RESOURCE, useQueryHook as useListPastStayPeriods };
